import React, { ReactNode, useEffect } from "react";
import { Loading } from "@/auth/Loading";
import { useAuth } from "@/auth/useAuth";

type Props = { children: ReactNode };

export const ProtectedRoute: React.FC<Props> = ({ children }) => {
    const { state, login } = useAuth();

    useEffect(() => {
        if (state.status === "unauthenticated") {
            login();
        }
    }, [state.status, login]);

    if (state.status === "authenticated") {
        return <>{children}</>;
    }

    return <Loading />;
};
